module.exports = __webpack_public_path__ + "img/Frame_8.93128a1e.png";